import * as React from "react";
const SvgSortArrow = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 12", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m15.063 6-1.256-1.058-4.979 4.185V0H7.047v9.127l-4.97-4.192L.813 6l7.125 6 7.125-6Z" }));
export default SvgSortArrow;
